module.exports = __webpack_public_path__ + "static/media/AU 2018 Research Roster.bf283c0c.csv";